import { render, staticRenderFns } from "./HowWork.vue?vue&type=template&id=49c74f35&"
import script from "./HowWork.vue?vue&type=script&lang=js&"
export * from "./HowWork.vue?vue&type=script&lang=js&"
import style0 from "./HowWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports